import { defineComponent as t, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as l, renderSlot as c, createElementVNode as s } from "vue";
import i from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M17.983 7.233l-2.21 11.914a1.045 1.045 0 01-2.033.094l-1.646-5.798-6.044.028a1.044 1.044 0 01-.468-1.978l10.91-5.385a1.046 1.046 0 011.49 1.125z"
}, null, -1), f = /* @__PURE__ */ t({
  name: "MyLocation",
  __name: "my-location",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (o, d) => (r(), a(i, n(p(e.props)), {
      default: l(() => [c(o.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
